/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Createorganization1Inputs */

const zh_share_createorganization1 = /** @type {(inputs: Share_Createorganization1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建或加入组织以分享。`)
};

const en_share_createorganization1 = /** @type {(inputs: Share_Createorganization1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create or join one to share.`)
};

const es_share_createorganization1 = /** @type {(inputs: Share_Createorganization1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea o únete a una para compartir.`)
};

/**
* | output |
* | --- |
* | "Create or join one to share." |
*
* @param {Share_Createorganization1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const share_createorganization1 = /** @type {((inputs?: Share_Createorganization1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Createorganization1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_share_createorganization1(inputs)
	if (locale === "en") return en_share_createorganization1(inputs)
	return es_share_createorganization1(inputs)
});
export { share_createorganization1 as "share_createOrganization" }